import { Component } from '@angular/core';

@Component({
  selector: 't-transflo-mobile-plus-icon',
  standalone: true,
  imports: [],
  templateUrl: './transflo-mobile-plus-icon.component.html',
  styleUrl: './transflo-mobile-plus-icon.component.css',
})
export class TransfloMobilePlusIconComponent {}
